@use "../../styles/breakpoints";
@use "../../styles/text";

hp6-pagination-control {
  .pagination-control-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @include breakpoints.small-up {
      justify-content: center;
    }

    .pagination-control-button {
      /** START | style resets **/
      margin: 0;
      border: none;
      background: none;
      appearance: none;
      /** END | style resets **/
      cursor: pointer;

      &.hidden {
        visibility: hidden;
      }

      hp6-icon {
        --system-color: var(--color-neutral-dark);
        --brand-color-path-one: var(--color-neutral-dark);
        --brand-color-path-two: var(--color-neutral-dark);
      }

      &:focus {
        hp6-icon {
          --system-color: var(--color-link-dark);
          --brand-color-path-one: var(--color-link-dark);
          --brand-color-path-two: var(--color-link-dark);
        }
      }

      &:hover {
        hp6-icon {
          --system-color: var(--color-link-dark);
          --brand-color-path-one: var(--color-link-dark);
          --brand-color-path-two: var(--color-link-dark);
        }
      }

      &:active {
        hp6-icon {
          --system-color: var(--color-link-xdark);
          --brand-color-path-one: var(--color-link-xdark);
          --brand-color-path-two: var(--color-link-xdark);
        }
      }
    }

    hp6-text-select {
      margin-top: var(--spacing-sm);
      margin-bottom: var(--spacing-sm);
      margin-left: auto;
      margin-right: auto;

      @include breakpoints.small-up {
        margin-left: var(--spacing-lg);
        margin-right: var(--spacing-lg);
      }
    }

    .single-page {
      color: var(--color-text-base);
      display: flex;
      flex-direction: row;
      align-items: center;

      margin-top: var(--spacing-sm);
      margin-bottom: var(--spacing-sm);

      .single-page-label {
        margin-right: var(--spacing-xxs);
      }

      &.xxs {
        .single-page-label {
          @include text.text-heading-xxs;
        }

        .single-page-one {
          @include text.text-body-xs;
        }
      }

      &.xs {
        .single-page-label {
          @include text.text-heading-xs;
        }

        .single-page-one {
          @include text.text-body-sm;
        }
      }

      &.sm {
        .single-page-label {
          @include text.text-heading-sm;
        }

        .single-page-one {
          @include text.text-body-md;
        }
      }

      &.md {
        .single-page-label {
          @include text.text-heading-md;
        }

        .single-page-one {
          @include text.text-body-lg;
        }
      }
    }
  }
}
